/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const MemberShipTiersBenefits = dynamic(() =>
  import('./MemberShipTiersBenefits').then(mod => mod.MemberShipTiersBenefits)
);

export const MemberShipTiersBenefitsConfig = {
  emptyLabel: 'memberShipTiersBenefits',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/membershiptiersbenefits`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MemberShipTiersBenefitsEditable = (props: any) => (
  <EditableComponent config={MemberShipTiersBenefitsConfig} {...props}>
    <MemberShipTiersBenefits {...props} />
  </EditableComponent>
);
